import React, { useState } from "react";
import { FiChevronDown, FiChevronUp, FiHelpCircle } from "react-icons/fi";

const FAQs = ({ faqsData }) => {
  const faqs = JSON.parse(faqsData);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faqs">
      <div className="faqs-header">
        <FiHelpCircle className="faqs-icon" />
        <h2>Frequently Asked Questions</h2>
        <p className="faqs-subtitle">Find answers to common questions about this tour</p>
      </div>
      
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            key={index}
          >
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <div className="question-content">
                <span className="question-number">Q{index + 1}</span>
                <span className="question-text">{faq.question}</span>
              </div>
              <div className="question-toggle">
                {activeIndex === index ? <FiChevronUp /> : <FiChevronDown />}
              </div>
            </div>
            <div className={`faq-answer ${activeIndex === index ? "active" : ""}`}>
              <div className="answer-content">
                <div className="answer-icon">A</div>
                <div className="answer-text">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;